import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-privacy',
  imports: [RouterLink],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyComponent implements OnInit {
  private readonly seo = inject(SeoService);
  private readonly siteConfig = inject(SiteConfigService);

  readonly contactInfo = this.siteConfig.contactInfo;

  ngOnInit(): void {
    this.seo.apply({
      title: 'Adatvédelmi nyilatkozat – ALL-IN-DEV',
      description: 'Az ALL-IN-DEV adatvédelmi nyilatkozata.',
      ogTitle: 'Adatvédelmi nyilatkozat – ALL-IN-DEV',
      ogDescription: 'Az ALL-IN-DEV adatvédelmi nyilatkozata.',
    });
  }
}
